<template>
	<RouterView />
</template>
<script>
import { useAppointmentReferralStore } from './stores/appointmentReferralStore.js';

export default {
	watch: {
		'$route.name'(newName, oldName) {
			if (newName !== undefined) {
				const appointmentReferralStore = useAppointmentReferralStore();
				let dataLayerObject = {
					'event': 'FAAppointmentStep',
					'step': newName, //The step name given after the # in the URL
				}
				if (oldName === 'profession') {
					dataLayerObject.profession = appointmentReferralStore?.customerProfession?.text;
				}
				else if (oldName === 'your-financial-adviser') {
					dataLayerObject.advisor = appointmentReferralStore?.financialAdviser?.firstName + ' ' + appointmentReferralStore?.financialAdviser?.lastName
				}
				
				// datalayer is not initialised instantly, wait 500ms
				setTimeout(() => {
					if (window.dataLayer) {
						window.dataLayer.push(dataLayerObject);
					}
				}, 500)
			}
		}
	},
}
</script>
<style scoped></style>
